import type { ComponentProps } from 'react'
import { cn } from '../../lib/cn'
import { controlClass, useFieldControl } from './field'

/** A short list to choose one value from, in a Field: the browser's own, on every device. */
export function Select({ className, ...props }: ComponentProps<'select'>) {
  return <select className={cn(controlClass, className)} {...useFieldControl()} {...props} />
}
